export default "__VITE_ASSET__3c0dbe9a__"